export default {
  users: 'Users',
  index: 'Index',
  dashboard: 'Dashboard',
  add: 'Add',
  edit: 'Edit',
  profile: 'Profile',
  changePassword: 'Change Password',
  roles: 'Roles',
  coupons: 'Coupons',
  devices: 'Devices',
  payments: 'Payments',
  organizations: 'Organizations',
  workingSites: 'Working Sites',
  realms: 'Realms',
  paymentConfigs: 'Payment Configs',
  myDevices: 'My Devices',
  myConsulars: 'My Consulars',
}
